import { useState, useCallback } from 'react'

type EditGroupModalData = {
  id: string
  name: string
  description?: string
}

type UseEditGroupModalProps = {
  onSuccess?: () => void
}

export function useEditGroupModal({ onSuccess }: UseEditGroupModalProps = {}) {
  const [isOpen, setIsOpen] = useState(false)
  const [modalData, setModalData] = useState<EditGroupModalData | null>(null)

  const openModal = useCallback((data: EditGroupModalData) => {
    setModalData(data)
    setIsOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setIsOpen(false)
    setModalData(null)
  }, [])

  const handleSuccess = useCallback(() => {
    onSuccess?.()
  }, [onSuccess])

  return {
    isOpen,
    modalData,
    openModal,
    closeModal,
    onSuccess: handleSuccess
  }
}
